/* ============================================================
   VIVĀRA — PRODUCT CONFIGURATION (single source of truth)
   ------------------------------------------------------------
   Every price, size, serving and policy figure on the site is painted
   from this object. Nothing may be hard-coded in markup; markup carries
   the same value only as a no-flash default, and is overwritten here.

   SHOPIFY MIGRATION
   -----------------
   oneTimePrice        → product.selected_or_first_available_variant.price
   subscriptionPrice   → selling_plan_allocation.price
   savings             → selling_plan_allocation.compare_at_price - price
   size / servings     → product metafields (namespace `label`)
   sku / availability  → variant.sku / variant.available
   The data-* hooks in the markup are named for a direct swap.
   ============================================================ */
(function () {
  "use strict";

  var CONFIG = {
    /* ---------- identity ---------- */
    handle: "the-drop",                       // live Shopify product handle
    url: "/products/the-drop",
    /* Live Shopify variant. purchase.js posts to /cart/add with this id the
       moment VIVARA_SITE.cartEnabled is switched on. */
    variantId: "44367042805896",
    title: "Element 003",
    subtitle: "Shilajit Drops",
    fullName: "Element 003 Shilajit Drops",

    sku: "01",
    availability: "InStock",

    /* ---------- size ---------- */
    size: "30 mL",
    netContents: "30 mL",

    /* ---------- price ---------- */
    currency: "USD",
    symbol: "$",
    oneTimePrice: 88.0,
    subscriptionPrice: 68.0,
    subscriptionIntervalDays: 30,

    /* Live Shopify selling plan — "Join The Ritual", Shopify Subscriptions,
       $68.00 monthly. The theme overwrites price and id from the storefront's
       own selling-plan allocation, so the page can never quote a figure the
       checkout will not honour. */
    sellingPlanId: "5152178312",
    sellingPlanName: "Join The Ritual",

    /* ---------- dosage --------------------------------------------------
       "Suggested use" is confirmed. The measured serving figures below are
       NOT — they stay null so no supply-duration or per-serving claim can
       be printed. Supply each value and the label section publishes itself. */
    suggestedUse:
      "Take 1–2 full droppers, up to three times a day. Straight, or in water, " +
      "a smoothie or coffee.",
    suggestedUseShort: "up to 1–2 full droppers, 3× daily",
    /* Plain-language line shown beside the price. */
    suggestedUsePlain: "1–2 dropperfuls, up to 3 times a day.",
    /* Short form for the closing call to action. */
    suggestedUseDaily: "1–2 dropperfuls daily",
    /* Highest intake the suggested use permits, used only to bound the supply
       calculation below. Never printed on its own. */
    maxDroppersPerDay: 6,

    label: {
      /* 0.7 mL per full dropper is the figure VIVĀRA publishes on its own
         Sourcing and FAQ pages for the DIN18 dropper. Everything below is
         arithmetic on that number and the 30 mL bottle — nothing is guessed. */
      dropperVolumeMl: 0.7,      // volume of ONE full dropper, in mL
      servingSize: null,         // official serving size as printed on the label
      servingsPerContainer: null,
      ingredientAmounts: null,   // [{ name, amount, dailyValue }]
      otherIngredients: null,
      warnings: null,
      storage: null,
      allergens: null,
      manufacturer: null,        // manufacturer / packer / distributor line
      servingsPerBottle: 42      // 30 mL ÷ 0.7 mL, rounded down
    },

    /* ---------- policy (confirmed) ---------- */
    policy: {
      returnWindowDays: 30,
      refundProcessing: "7–14 business days",
      processingTime: "3–5 business days",
      domesticDelivery: "1–5 business days",
      internationalDelivery: null,   // not confirmed — nothing published
      freeShippingThreshold: null    // not confirmed — nothing published
    },

    /* ---------- derived ---------- */
    format: function (v) {
      return this.symbol + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
    },
    savings: function () {
      return this.oneTimePrice - this.subscriptionPrice;
    },
    savingsLabel: function () {
      return "Save " + this.format(this.savings());
    },
    /* How long a bottle lasts. Honest by default: until the servings per
       bottle are measured, this says only what is true. Fill in
       label.servingsPerBottle and the exact range prints itself, everywhere,
       with no markup change.
       SHOPIFY → product metafield `label.servings_per_bottle`. */
    bottleDuration: function () {
      var n = this.label.servingsPerBottle;
      if (!n) return "Bottle duration varies based on daily use.";
      /* Two short sentences, because that is how the question is asked. Both
         numbers are arithmetic on the 0.7 mL dropper and the 30 mL bottle:
         a dropperful or two a day is roughly a month, the full three times a
         day is roughly a fortnight. */
      function weeks(w) {
        if (w >= 4) return "about a month";
        if (w <= 1) return "about a week";
        return ["", "", "two", "three"][w] + " weeks";
      }
      var everyday = weeks(Math.round(n / 1.5 / 7));
      var full = weeks(Math.round(n / this.maxDroppersPerDay * 2 / 7));
      return everyday.charAt(0).toUpperCase() + everyday.slice(1) + ". " +
             full.charAt(0).toUpperCase() + full.slice(1) + " if you take it three times a day.";
    },

    /* Only produce a supply duration when the measured serving supports it. */
    supplyDuration: function () {
      var ml = this.label.dropperVolumeMl;
      if (!ml) return null;
      var perBottle = 30 / ml;                 // 30 mL bottle
      var max = Math.floor(perBottle / 3);     // lightest use: 1 dropper, 3× daily
      var min = Math.floor(perBottle / this.maxDroppersPerDay);  // heaviest: 2 droppers, 3× daily
      return min === max ? max + " day supply" : min + "–" + max + " day supply";
    }
  };

  /* ---------- declarative painting ---------- */
  CONFIG.paint = function (root) {
    var scope = root || document;
    var map = {
      oneTime:      CONFIG.format(CONFIG.oneTimePrice),
      subscription: CONFIG.format(CONFIG.subscriptionPrice),
      savings:      CONFIG.format(CONFIG.savings()),
      savingsLabel: CONFIG.savingsLabel()
    };

    scope.querySelectorAll("[data-price]").forEach(function (el) {
      var v = map[el.getAttribute("data-price")];
      if (v != null) el.textContent = v;
    });
    scope.querySelectorAll("[data-product-size]").forEach(function (el) {
      el.textContent = CONFIG.size;
    });
    scope.querySelectorAll("[data-product-name]").forEach(function (el) {
      el.textContent = CONFIG.fullName;
    });
    scope.querySelectorAll("[data-suggested-use]").forEach(function (el) {
      el.textContent = CONFIG.suggestedUse;
    });
    scope.querySelectorAll("[data-suggested-use-short]").forEach(function (el) {
      el.textContent = CONFIG.suggestedUseShort;
    });
    scope.querySelectorAll("[data-suggested-use-plain]").forEach(function (el) {
      el.textContent = CONFIG.suggestedUsePlain;
    });
    scope.querySelectorAll("[data-suggested-use-daily]").forEach(function (el) {
      el.textContent = CONFIG.suggestedUseDaily;
    });
    scope.querySelectorAll("[data-bottle-duration]").forEach(function (el) {
      el.textContent = CONFIG.bottleDuration();
    });
    scope.querySelectorAll("[data-interval-days]").forEach(function (el) {
      el.textContent = CONFIG.subscriptionIntervalDays;
    });
    scope.querySelectorAll("[data-policy]").forEach(function (el) {
      var v = CONFIG.policy[el.getAttribute("data-policy")];
      if (v) el.textContent = v;
    });

    /* Supply duration is removed from the page unless it can be calculated. */
    var supply = CONFIG.supplyDuration();
    scope.querySelectorAll("[data-supply-duration]").forEach(function (el) {
      if (supply) el.textContent = supply;
      else el.remove();
    });

    /* The Supplement Facts panel only renders with real label data. */
    var hasLabel = !!(CONFIG.label.servingSize && CONFIG.label.ingredientAmounts);
    scope.querySelectorAll("[data-label-panel]").forEach(function (el) {
      if (hasLabel) return;
      var item = el.closest("[data-faq-item]") || el;
      var list = item.parentElement;
      item.remove();
      /* never leave an empty accordion shell behind */
      if (list && !list.children.length) list.remove();
    });
  };

  /* On Shopify the storefront's own figures win, so the page and the cart can
     never disagree. Off Shopify the values above stand. */
  if (window.VIVARA_SHOPIFY) {
    var S = window.VIVARA_SHOPIFY;
    if (typeof S.price === "number" && S.price > 0) CONFIG.oneTimePrice = S.price;
    if (typeof S.subscriptionPrice === "number" && S.subscriptionPrice > 0) {
      CONFIG.subscriptionPrice = S.subscriptionPrice;
    }
    if (S.sellingPlanId) CONFIG.sellingPlanId = String(S.sellingPlanId);
    if (S.variantId) CONFIG.variantId = String(S.variantId);
    if (S.sku) CONFIG.sku = S.sku;
    if (S.url) CONFIG.url = S.url;
  }

  window.VIVARA_PRODUCT = CONFIG;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { CONFIG.paint(document); });
  } else {
    CONFIG.paint(document);
  }
})();
